import Container from "../Container";
import Title from "../Title";
import { Content, Text } from "./style";

type ContextText = {
  title: string;
  children: React.ReactNode;
};

export default function ContentText({ title, children }: ContextText) {
  return (
    <Content>
      <Container>
        <div style={{ width: "80%", margin: "0 auto", textAlign: "center" }}>
          <Title name={title} secondarySection />
        </div>
        <Text>{children}</Text>
      </Container>
    </Content>
  );
}
